import styled from "styled-components"
import { phoneWidth } from "../Globalstyle"

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: row;
  padding: 50px var(--side-padding);
  gap: 5rem;
  border-top: 1px solid var(--light-gray);
  /* background-color: black; */

  @media (max-width: ${phoneWidth}) {
    flex-direction: column;
    gap: 3rem;
  }
`

const Contact = styled.div`
  color: var(--gray-300);
`

const LinksContainer = styled.div``

const Title = styled.div`
  font-weight: bold;
  margin-bottom: 1rem;
  color: white;
`

const Links = styled.div`
  display: flex;
  gap: 40px;
  line-height: 1.5rem;
  font-style: italic;
`

const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const Link = styled.a`
  text-decoration: none;
  color: var(--gray-300);
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`

const Footer = () => {
  return (
    <StyledFooter>
      <Contact>
        <Title>Contact</Title>
        <div>AWR NIB Tower</div>
        <div>11th Floor, House 99, Road 11, Block C</div>
        <div>Banani, Dhaka-1213, Bangladesh</div>
        <br/>
        <div>Phone No: 01676905388</div>
        <div>Email: info@spacedawgbd.com</div>
      </Contact>

      <LinksContainer>
        <Title>Links</Title>
        <Links>
          <LinkColumn>
            <Link href="https://directfreshbd.com/" target="_blank">
              Direct Fresh
            </Link>
            <Link href="https://www.spacedawgbd.com/" target="_blank">
              Space Dawg
            </Link>
            <Link href="https://www.thrive-global.org/" target="_blank">
              Thrive
            </Link>
            <Link href="https://www.jaago.com.bd/" target="_blank">
              Jaago
            </Link>
            <Link href="https://www.the-40.com/" target="_blank">
              Noor E Farid Nasrine Academy
            </Link>
          </LinkColumn>
        </Links>
      </LinksContainer>
    </StyledFooter>
  )
}

export default Footer